import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { AnimatedLines } from "@/components/landing/AnimatedLines";

export const Breadcrumb = ({ items }) => (
  <nav aria-label="Fil d'ariane" className="flex items-center flex-wrap gap-1 text-sm text-muted-foreground">
    {items.map((it, i) => (
      <span key={it.label} className="flex items-center gap-1">
        {i > 0 && <ChevronRight className="w-3.5 h-3.5" />}
        {it.to ? (
          <Link to={it.to} className="hover:text-ink transition-colors">
            {it.label}
          </Link>
        ) : (
          <span className="text-ink font-semibold">{it.label}</span>
        )}
      </span>
    ))}
  </nav>
);

export const CtaBand = ({ onReserve, onBook, title, subtitle }) => (
  <section className="relative overflow-hidden bg-ink text-white py-16">
    <AnimatedLines variant="dark" />
    <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
      <h2 className="font-heading font-extrabold text-2xl sm:text-3xl tracking-tight">{title}</h2>
      {subtitle && <p className="text-white/70 mt-3">{subtitle}</p>}
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        {onBook && (
          <button
            data-testid="cta-band-book-btn"
            onClick={onBook}
            className="cta inline-flex items-center gap-2 bg-royal text-white font-extrabold px-8 py-4 rounded-sm hover:bg-royal-hover shadow-lg shadow-royal/30"
          >
            Réserver mon créneau
          </button>
        )}
        <button
          data-testid="cta-band-btn"
          onClick={onReserve}
          className={`cta inline-flex items-center gap-2 font-bold px-8 py-4 rounded-sm ${
            onBook
              ? "border border-white/40 text-white hover:bg-white hover:text-ink"
              : "bg-royal text-white hover:bg-royal-hover shadow-lg shadow-royal/30"
          }`}
        >
          Obtenir mon devis
        </button>
      </div>
    </div>
  </section>
);
